// @ts-check
import siteLanguage from "./siteLanguage";

/**
 * Some funds may not have a profile link included. When this is the case,
 * fallback to its first purchase option's URL instead.
 *
 * @param fund {object}
 */
export const fundLink = (fund) => {
	let response = fund.fields[`fund_profile_link_${window.siteLanguage}`];

	if (!response && fund.fields.fund_purchase_options.length > 0) {
		response =
			fund.fields.fund_purchase_options[0][
				`fund_profile_link_${window.siteLanguage}`
			];
	}

	return response;
};

export const primaryRefinitivId = (result) => {
	if (!result.fields.fund_details_link_path) {
		return result._id;
	}

	return result.fields.fund_details_link_path[0].replace(/\D/g, "");
};

export const kypReport = (id) => {
	if (!window.KYP_REPORTS) {
		return null;
	}

	const response = window.KYP_REPORTS.find((report) => report.id === id);

	if (!response || !response.kypReport) {
		return null;
	}

	return response.kypReport.url;
};

/**
 * This function is no longer used
 */
// export const fundPerformance = (id, property) => {
// 	if (!window.FUND_PERFORMANCE) {
// 		return null;
// 	}
// 	const response = window.FUND_PERFORMANCE.find((report) => report.id === id);
// 	if (!response) {
// 		return null;
// 	}
// 	return response[property] || null;
// };

export const fundFacts = (id) => {
	const getDefaultURL = () => {
		if (siteLanguage === "fr") {
			return "https://fundfacts.bmo.com/AdvisorFrench/index.html";
		}

		return "https://fundfacts.bmo.com/AdvisorEnglish/index.html";
	};

	if (!window.FUND_FACTS) {
		return getDefaultURL();
	}

	const response = window.FUND_FACTS.find((report) => report.id === id);

	if (!response || !response.fundFacts) {
		return getDefaultURL();
	}

	return response.fundFacts.url.replace('http://', 'https://');
};
